/** @jsx jsx */
import { jsx } from "theme-ui"

import GridRow from "../../../atoms/GridRow"

export const Blocks = props => {
  const style = props.node.style || "normal"

  if (/^h\d/.test(style)) {
    return (
      <GridRow.Col
        as={style}
        sx={{ gridColumn: ["1 / -1", "1 / -1", "4 / span 9"] }}
      >
        {props.children}
      </GridRow.Col>
    )
  }

  return style === "blockquote" ? (
    <blockquote sx={{ gridColumn: "1 / -1" }}></blockquote>
  ) : (
    <p sx={{ gridColumn: ["1 / -1", "1 / -1", "span 9 / -4"] }}>
      {props.children}
    </p>
  )
}
